import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, SproutIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    const target = document.querySelector('#pricing');
    if (target) {
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      const duration = 2000; // 2 seconds for slow scroll
      let start: number | null = null;
      function animation(currentTime: number) {
        if (start === null) start = currentTime;
        const timeElapsed = currentTime - start;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      }
      function ease(t: number, b: number, c: number, d: number) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      }
      requestAnimationFrame(animation);
    }
  };
  return <section className="relative w-full overflow-hidden bg-[#f5f0e1]" data-id="element-137">
      {/* Hero Image Container */}
      <div className="w-full relative" data-id="element-138">
        <img src="https://cdn.magicpatterns.com/uploads/99id15Kv4VCpMr3rqExgsp/ChatGPT_Image_5_jun_2026,_02_40_32.webp" alt="Recetario Ancestral - Viví mejor desde tus raíces" className="w-full h-auto block" fetchPriority="high" loading="eager" decoding="async" data-id="element-139" />

        {/* Content Overlay - Positioned at the bottom edge of the image */}
        <div className="absolute inset-x-0 bottom-0 pb-8 md:pb-12 flex flex-col items-center text-center z-10" data-id="element-140">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex flex-col items-center" data-id="element-141">
            <motion.button onClick={scrollToPricing} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0,
            scale: [1, 1.02, 1]
          }} transition={{
            opacity: {
              duration: 0.8,
              delay: 0.5
            },
            y: {
              duration: 0.8,
              delay: 0.5
            },
            scale: {
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }
          }} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} className="bg-[#f5f0e1] text-[#0f1711] pl-8 pr-4 py-4 rounded-2xl font-medium text-xl md:text-2xl shadow-xl hover:bg-white transition-all flex items-center group border border-[#0f1711]/10 pt-[0px] pb-[0px] mt-[0px] mb-[0px] gap-[24px]" data-id="element-142">
              <div className="flex items-center gap-4" data-id="element-143">
                <SproutIcon className="w-8 h-8 text-[#8b7355] opacity-80" data-id="element-144" />
                <span className="tracking-tight uppercase font-serif" data-id="element-145">
                  Quiero mi recetario
                </span>
              </div>

              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-[#8b7355] flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform" data-id="element-146">
                <ArrowRightIcon className="w-6 h-6 md:w-8 md:h-8" data-id="element-147" />
              </div>
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>;
}